import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-human",
  "use": "icon-icon-human-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-human\"><polygon points=\"600.74 557.41 569.41 593.82 542.02 626.45 617.91 708.28 515.79 826.32 405.4 707.85 540.32 547.16 737.8 317.64 514.74 64.88 286.11 330.95 420.76 469.61 444.05 441.87 479.39 400.8 407.96 327.24 515.64 201.92 618.42 318.39 471.92 488.67 285.28 710.95 518.28 961 738.72 706.2 600.74 557.41\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol